import axios from 'axios';
import { useEffect } from 'react';
import { Loading } from 'shell/components';

const APILaunch = (props) => {
    useEffect(() => {
        const params = new URLSearchParams(props.location.search);
        const code = params.get('code');
        const state = params.get('state');
        const isLtiOauthAfterLaunch = sessionStorage.getItem('lti_oauth_after_launch') === 'true';
        const existingAuthToken = localStorage.getItem('auth_token');

        if (!isLtiOauthAfterLaunch) {
            localStorage.removeItem('auth_token');
        }

        if (code) {
            (async () => {
                const launchAPI = await axios.post('/get-user-context', {
                    code: code,
                    state,
                    course_id: localStorage.getItem('course_id'),
                    lti_auth_token: isLtiOauthAfterLaunch ? existingAuthToken : null,
                });
                if (!launchAPI?.access_token && !launchAPI?.access) {
                    window.location.href = '/lti-incomplete';
                } else {
                    localStorage.setItem('access_token', launchAPI.access_token);
                    localStorage.setItem('refresh_token', launchAPI.refresh_token);
                    if (isLtiOauthAfterLaunch && existingAuthToken) {
                        localStorage.setItem('auth_token', existingAuthToken);
                    } else {
                        localStorage.setItem('auth_token', launchAPI.token);
                    }

                    const returnPath = sessionStorage.getItem('lti_oauth_return_path') || '/';
                    sessionStorage.removeItem('lti_oauth_after_launch');
                    sessionStorage.removeItem('lti_oauth_return_path');
                    window.location.href = isLtiOauthAfterLaunch ? returnPath : '/';
                }
            })();
        } else {
            (async () => {
                const authorizeURL = await axios.post('/get-access-token');
                window.location.href = authorizeURL;
            })();
        }
    }, [props.location.search]);

    return <Loading />;
};

export default APILaunch;
